import React, { useState, useEffect } from "react";
import { siteConfig } from "../../config/siteConfig";
import SealChip from "../ui/SealChip";

// Barra CTA fija en la parte inferior (solo móvil). Aparece tras hacer scroll
// más allá del Hero, usando el mismo listener de scroll pasivo + rAF-throttled
// que comparte la Navbar (sin JS de scroll nuevo). Gran palanca de conversión en móvil.
// Solo conmuta una clase translate → 0 CLS (fixed/translate únicamente).
const StickyCTA = ({ onCtaClick }) => {
  const [show, setShow] = useState(false);
  const { hero, pricing } = siteConfig;
  const plan = pricing && pricing.plan ? pricing.plan : {};
  // Reasegura compacta dockada (anti-ansiedad), siempre desde config con fallback seguro.
  const reassureLabel = (pricing && pricing.stickyNote) || "";

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 700);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      className={`lg:hidden fixed bottom-0 left-0 right-0 z-40 transition-transform duration-300 ${
        show ? "translate-y-0" : "translate-y-full"
      }`}
    >
      <div
        className="glass-header border-t border-slate-200/70 elev-3 px-4 py-3 flex items-center justify-between gap-3"
        style={{ paddingBottom: "calc(0.75rem + env(safe-area-inset-bottom))" }}
      >
        <div className="leading-tight">
          <div className="text-base font-extrabold text-slate-900 tabular-nums">
            {plan.currency}
            {plan.price}
            <span className="text-xs font-semibold text-slate-400">{plan.period}</span>
          </div>
          {reassureLabel ? (
            <SealChip
              label={reassureLabel}
              icon="no-lock"
              className="mt-1 px-2 py-0.5"
            />
          ) : null}
        </div>
        <button
          onClick={onCtaClick}
          className="btn-primary glow-cta flex-1 max-w-[58%] py-3 min-h-[44px] text-base"
        >
          {(hero && hero.primaryCta) || "Aloita ilmaiseksi"}
        </button>
      </div>
    </div>
  );
};

export default StickyCTA;
